import {ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild} from '@angular/core';

export interface  AcDropdownChild{
    displayName: string;
    enabled?: boolean;
    onClick?: Function;
    doesntRequireSelection?: boolean;
    children?: AcDropdownChild[];
    icon?: string;
    svgName?: string;
    template?: TemplateRef<any>;
    id?: string;
    templateData?: any;
}

@Component({
    selector: 'ac-drop-down-menu',
    templateUrl: './ac-dropdown-menu.component.html',
    styleUrls: ['./ac-dropdown-menu.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcDropDownMenuComponent {
    @Input() items: AcDropdownChild[];
    @Input() buttonText = '';
    @Input() dropdownId;
    @Input() icon;
    @Input() isMainButton = true;
    @Input() ngDisabled = false;
    @ViewChild('childMenu', {static: true}) public childMenu;

    atLeastOneChildIsEnabled = (children) => children.some((child) => (child.enabled === undefined || child.enabled === true));
}
